import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { DeleteRoomMutation } from "./mutation";
import { RoomList_ListPage_Query } from "./query";

export const useDeleteRoom = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { mutationFunc } = useCustomMutation(DeleteRoomMutation, {});
	const _onDeleteRoom = useCallback(
		async ({ hotelID, roomID }: { hotelID: string; roomID: string }) => {
			return await mutationFunc({
				variables: { hotelID, roomId: roomID },
				refetchQueries: [
					{
						query: RoomList_ListPage_Query,
						variables: {
							hotelID,
						},
					},
				],
			});
		},
		[mutationFunc],
	);

	const onDeleteRoom = useCallback(
		async ({ hotelID, roomID }: { hotelID: string; roomID: string }) => {
			if (window.confirm("本当に削除しますか？") === false) return;

			showLoadingScreenCallback();

			const { errors } = await _onDeleteRoom({ roomID, hotelID }).finally(() => hideLoadingScreenCallback());

			if (!errors) {
				notifyUserEventInfo({ variant: "default", title: "部屋を削除しました" });
			}
		},
		[_onDeleteRoom, hideLoadingScreenCallback, showLoadingScreenCallback],
	);

	return {
		onDeleteRoom,
	};
};
